var $ = jQuery.noConflict();

$(window).on('load', function () {
    let method = 'front';
    if ($('body').hasClass('wp-admin'))
        method = 'wp-admin';

    const getYoutubeIframe = (id) => {
        let iframe = document.createElement( 'iframe' );
        iframe.setAttribute( 'frameborder', '0' );
        iframe.setAttribute( 'allowfullscreen', '' );
        iframe.setAttribute( 'allow', 'autoplay' )
        iframe.setAttribute( 'src', 'https://www.youtube.com/embed/'+ id +'?rel=0&autoplay=1&mute=0&enablejsapi=1' );
        return iframe;
    }
    const getVimeoIframe = (id) => {
        let iframe = document.createElement( 'iframe' );
        iframe.setAttribute( 'frameborder', '0' );
        iframe.setAttribute( 'allowfullscreen', '' );
        iframe.setAttribute( 'allow', 'autoplay' )
        iframe.setAttribute( 'src', 'https://player.vimeo.com/video/' + id + '?autoplay=1' );
        return iframe;
    }

    const getVimeoThumb = (videoid, container) => {
        fetch(`https://vimeo.com/api/v2/video/${videoid}.json`)
        .then(response => {
            return response.text();
        })
        .then(data => {
            const { thumbnail_large, thumbnail_medium, thumbnail_small } = JSON.parse(data)[0];
            let image = new Image();
            image.src = thumbnail_large;
            image.className += "block-testimonial__img";
            image.addEventListener( 'load', function() {
                container.appendChild( image );
            }() );
        })
        .catch(error => {
          console.log(error);
        });
    }

    const getYoutubeThumb = (videoid, container) => {
        let source = 'https://img.youtube.com/vi/'+ videoid +'/maxresdefault.jpg';
        let image = new Image();
            image.src = source;
            image.className += "block-testimonial__img";
            image.addEventListener( 'load', function() {
                container.appendChild( image );
            }() );
    }
      
    var initializeBlock = function ($block) {
        let video = document.querySelectorAll( '.block-testimonial__video' );
  
        for (let i = 0; i < video.length; i++) {
            
            if ( video[i].dataset.id === '' ) continue;
            
            if ( method === 'wp-admin' && video[i].querySelector('.block-testimonial__img') ) {
                video[i].querySelector('.block-testimonial__img').remove();
            }
           
            if ( video[i].querySelector('.block-testimonial__custom-img') === null ) {
                if ( video[i].dataset.type === 'youtube' ) {
                    getYoutubeThumb(video[i].dataset.id , video[i]);
                }
                if ( video[i].dataset.type === 'vimeo' ) {
                    getVimeoThumb(video[i].dataset.id , video[i]);
                }
            }
            if ( method === 'front' ) {
                video[i].addEventListener( 'click', function() {
                    let iframe = '';
                    if ( video[i].dataset.type === 'youtube' ) {
                        iframe = getYoutubeIframe(video[i].dataset.id); 
                        this.innerHTML = '';
                        this.appendChild( iframe );
                    }
                    if ( video[i].dataset.type === 'vimeo' ) {
                        iframe = getVimeoIframe(video[i].dataset.id); 
                        this.innerHTML = '';
                        this.appendChild( iframe );
                    }
                } );  
            }
        };

    };

    window.onload = function () {
        initializeBlock($(this));
    }();

    if (window.acf) {
        window.acf.addAction('render_block_preview/type=testimonials', initializeBlock);
    }
});
